var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2193 5.28033C15.5122 4.98744 15.5122 4.51256 15.2193 4.21967C14.9264 3.92678 14.4515 3.92678 14.1586 4.21967L9.71948 8.65882L5.28033 4.21967C4.98744 3.92678 4.51256 3.92678 4.21967 4.21967C3.92678 4.51256 3.92678 4.98744 4.21967 5.28033L8.68934 9.75L4.21967 14.2197C3.92678 14.5126 3.92678 14.9874 4.21967 15.2803C4.51256 15.5732 4.98744 15.5732 5.28033 15.2803L9.71948 10.8412L14.1586 15.2803C14.4515 15.5732 14.9264 15.5732 15.2193 15.2803C15.5122 14.9874 15.5122 14.5126 15.2193 14.2197L10.7496 9.75L15.2193 5.28033Z",
    fill: "#4282E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.69c6b4678fc848010182beb3df705246.svg";
export { ForwardRef as ReactComponent };